// src/pages/network/MessagesPage.js
import React from 'react';
import { Link, useParams, useLocation } from 'react-router-dom';
import { ArrowLeft, MessageSquare } from 'lucide-react';
import MessagingContainer from '../../components/network/messaging/MessagingContainer';
import { useAuth } from '../../context/AuthContext';

const MessagesPage = () => {
  const { conversationId } = useParams();
  const { currentUser } = useAuth();
  const location = useLocation();
  const isMobile = window.innerWidth < 1024;
  const showBackButton = isMobile || !!conversationId;

  // Get recipientId from navigation state (from profile Message button)
  const recipientId = location.state?.recipientId || null;
  const recipientName = location.state?.recipientName || null;

  return (
    <div className="container mx-auto max-w-6xl px-4 h-[calc(100vh-150px)] md:h-[calc(100vh-150px)] lg:h-[calc(100vh-200px)]">
      <div className="mb-4 flex items-center">
        {showBackButton ? (
          <Link
            to="/network"
            className="text-[#190192] hover:text-[#2C0DB5] inline-flex items-center"
          >
            <ArrowLeft size={16} className="mr-1" />
            Back to Network
          </Link>
        ) : (
          <div className="flex items-center">
            <MessageSquare size={18} className="text-[#190192] mr-2" />
            <h2 className="text-xl font-bold text-gray-900">Messages</h2>
          </div>
        )}
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden h-full">
        {!currentUser ? (
          <div className="flex h-full flex-col justify-center items-center bg-gray-50 p-6 text-center">
            <h3 className="text-lg font-medium text-gray-900 mb-2">Sign In to Message</h3>
            <p className="text-gray-500 mb-4">
              Connect with businesses through private messaging
            </p>
            <a
              href="/login?redirect=/network/messages"
              className="px-4 py-2 bg-[#190192] text-white rounded-lg hover:bg-[#2C0DB5]"
            >
              Sign In
            </a>
          </div>
        ) : (
          <MessagingContainer
            initialConversationId={conversationId}
            initialRecipientId={recipientId}
            initialRecipientName={recipientName}
          />
        )}
      </div>
    </div>
  );
};

export default MessagesPage;
